import PageHeaderText from 'components/base/page-header-text';
import React, { useEffect, useState } from 'react';
import { EditAltIcon } from 'cokitchen-icons';
import { Button, ToastMessage } from '@cokitchen/cokitchen-components';

import { useNavigate } from 'react-router-dom';
import { MAIN_STORE_ROUTE_KEYS, STORAGE_KEYS } from 'utils/constants';
import { toast } from 'react-toastify';
import { apiService } from 'services/base.service';
import useProductionReportContext from 'contexts/kitchen/production-report.context/context';

const ReviewMealDetails = () => {
  const { mealFormData, setMealFormData, setActive } = useProductionReportContext();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const defaultShowMealDetails = mealFormData.reduce((result, _, index) => {
    result[index] = false;
    return result;
  }, {} as Record<string, boolean>);
  const [showMealDetails, setShowMealDetails] = useState(defaultShowMealDetails);

  const toggleShowMealDetails = (idx: number) => {
    const show = showMealDetails[idx];
    setShowMealDetails((item) => ({
      ...item,
      [idx]: !show
    }));
  };

  const cokitchenId = localStorage.getItem(STORAGE_KEYS.COKITCHEN);

  const createBulkMeal = async () => {
    const data = {
      data: mealFormData.map((item) => ({
        cokitchen_id: cokitchenId,
        kitchen_item_name: item.meal_name,
        category: item.meal_category,
        section: item.section,
        minimun_stock_level: item.min_quantity
      }))
    };
    try {
      setLoading(true);
      const res = await apiService.post(`cokitchen-item/bulk-create/with-item-name`, {
        data
      });
      if (res) {
        toast(<ToastMessage type='success' message='Meals added successfully' />);
        setMealFormData([]);
        setActive(null);
        navigate(MAIN_STORE_ROUTE_KEYS.KITCHEN_PRODUCTION_REPORT);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (mealFormData.length === 0) navigate(MAIN_STORE_ROUTE_KEYS.KITCHEN_ADD_MEAL);
  }, []);
  return (
    <div className=' w-full  '>
      <div className='flex flex-col max-w-[400px] mx-auto  '>
        <PageHeaderText title='Review Items' description='Ensure to review each item added' />
        {mealFormData.map((meal, mealIndex) => (
          <div key={mealIndex} className=' '>
            <div className='flex justify-between bg-[#F8F8F8] p-3 rounded-t-md border border-[#F2F2F3] '>
              <div className='flex gap-1 items-center'>
                <h3 className='font-medium text-[#2E3031]'>{meal.meal_name}</h3>
                <EditAltIcon
                  onClick={() => {
                    setActive('manual');
                    setMealFormData(mealFormData);
                    navigate(MAIN_STORE_ROUTE_KEYS.KITCHEN_ADD_MEAL);
                  }}
                  className='cursor-pointer'
                />
              </div>
              <div
                onClick={() => toggleShowMealDetails(mealIndex)}
                className='bg-white border border-[#EAEBEB] rounded-[100px] flex items-center justify-center text-xs font-medium text-[#5E6164] cursor-pointer shadow-sm w-[61px] h-[30px]'>
                {showMealDetails[mealIndex] ? 'Hide' : 'Show'}
              </div>
            </div>
            {showMealDetails[mealIndex] ? (
              <div className='border-x border-b border-[#F2F2F3] rounded-b-md'>
                <div className='flex justify-between p-3 text-sm border-b border-[#EAEBEB]'>
                  <p className='text-[#6F7376]'>Section</p>
                  <p className='text-[#2E3031] font-medium'>{meal.section}</p>
                </div>
                <div className='flex justify-between p-3 text-sm border-b border-[#EAEBEB]'>
                  <p className='text-[#6F7376]'>Category</p>
                  <p className='text-[#2E3031] font-medium'>{meal.meal_category}</p>
                </div>
                <div className='flex justify-between p-3 text-sm border-b border-[#EAEBEB]'>
                  <p className='text-[#6F7376]'>Min. qty</p>
                  <p className='text-[#2E3031] font-medium'>{meal.min_quantity}</p>
                </div>
              </div>
            ) : null}
          </div>
        ))}
        <Button
          loading={loading}
          onClick={createBulkMeal}
          color='primary'
          variant='block'
          small
          className='my-8'>
          Confirm
        </Button>
      </div>
    </div>
  );
};

export default ReviewMealDetails;
